import React from 'react';

const PageBody = (props) => (
    <div style={{...props.style}} className={`bottom dashboard-content-background ${props.customClass ? props.customClass : ''}`}>
        {props.children}
    </div>
);

export default PageBody